import { UserType } from "../api/types/user/IUser";
import { PagePath, PageSection, PageSlug } from "../navigation/routes";

export function isCurator(type: UserType | undefined): boolean {
  return type === "user";
}

export function isAdmin(type: UserType | undefined): boolean {
  return type === "admin";
}

export function canEditTicketGridPrices(type: UserType | undefined): boolean {
  return type === "admin" || type === "moderator" || type === "user";
}

export function canCreateTicketGrid(type: UserType | undefined): boolean {
  return type === "admin" || type === "moderator";
}

export function canManageTicketGrid(type: UserType | undefined): boolean {
  return type === "admin" || type === "moderator";
}

export function canViewTicketGridChildTemplates(type: UserType | undefined): boolean {
  return type === "admin" || type === "moderator";
}

export function isTicketGridChildTemplatesPath(pathname: string): boolean {
  const prefix = `${PageSection.ticketGrids}${PageSlug.templates}/`;
  if (!pathname.startsWith(prefix)) {
    return false;
  }

  const parentId = pathname.slice(prefix.length);
  return parentId.length > 0 && !parentId.includes("/");
}

export function canManageTicketGridReport(type: UserType | undefined): boolean {
  return type === "admin" || type === "moderator";
}

export function getUserTypeLabel(type: UserType): string {
  switch (type) {
    case "admin":
      return "Администратор";
    case "moderator":
      return "Аналитик";
    case "user":
      return "Куратор";
  }
}

export function getDefaultHomePath(type: UserType | undefined): string {
  if (isCurator(type)) {
    return PagePath.ticketGrids.templates;
  }
  return PagePath.parsing.jobs;
}

export function isCuratorAllowedPath(pathname: string): boolean {
  if (!pathname.startsWith(PageSection.ticketGrids)) {
    return false;
  }

  if (pathname === PagePath.ticketGrids.createTemplate) {
    return false;
  }

  return !isTicketGridChildTemplatesPath(pathname);
}

export function canAccessPath(type: UserType | undefined, pathname: string): boolean {
  if (!isCurator(type)) {
    return true;
  }

  return isCuratorAllowedPath(pathname);
}
